import { AxiosResponse } from "axios";
import httpClient from "../../api/httpClient";
import { SemanaBrf } from "../classes/SemanaBrf";

interface HttpCalls {
  method: string;
  rota: string;
}

const calls: HttpCalls[] = [
    { method: "GET", rota: "Semana/Ano" },
];

const apiServico: string = "DASHBOARD";

export default class SemanaDataset extends httpClient {
    constructor() {
      super(apiServico);
    }
  
    async getAll(
      ano: number
    ): Promise<SemanaBrf[]> {
      let ok: boolean = false;
      let data: SemanaBrf[];
      let error: any = undefined;
  
      await super
        .Get( `${calls[0].rota}/${ano}`)
        .then((response: AxiosResponse) => {
          ok = response.status === 200;
          data = response.data;
        })
        .catch((erro) => {
          ok = false;
          error = erro;
        });
      if (error !== undefined && ok === false) throw error;
      return new Promise<SemanaBrf[]>((resolve) => {
        resolve(data);
      });
    }
  }
  